import React from 'react';
import { Helmet } from 'react-helmet';
import Header4 from '../../components/header/header4/Header4'
import HerosectionB from '../../components/herosection/herosection_b/HeroSectionB';
import ShortAboutUs from '../../components/short_about_us/ShortAboutUs'
import ShortServicesSection from '../../components/short_services_section/ShortServicesSection'
import ShortOurProcesses from '../../components/short_our_processes/ShortOurProcesses'
// import ShortTestimonials from '../../components/short_testimonials/ShortTestimonials';
//import TestimonialSection2 from '../../components/testimonials_section/testimonialsection_2/TestimonialSection2';
import ShortIndustriesServed from '../../components/short_industries_served/ShortIndustriesServed'
import ShortClientCarousel from '../../components/short_client_carousel/ShortClientCarousel';
import WhatsappCallBtn from '../../components/whatsapp_call_btn/WhatsappCallBtn';
import Footer from '../../components/footer/Footer'


export default function Home() {
  return (
    <>
      <Helmet>
        <title>SARS India Liaison Pvt. Ltd. | Industrial Statutory compliance & Consulting Services</title>
        <meta
          name="description"
           content="SARS India Liaison is a an ISO-certified industrial statutory consulting company offering PESO approvals, environmental clearances, fire licensing, biomedical waste authorization, forest and groundwater NOCs, and end-to-end compliance services across India"
        />
        <meta name="keywords" content="Sars India, SARS India Liaison Pvt. Ltd., industrial statutory consulting, PESO approval, fire licensing, environmental clearance, forest clearance, CGWA NOC, biomedical waste authorization, fire NOC, EC, CTE, CTO, AAI clearance, clinical establishment licensing, government approvals, compliance audit, environmental consulting, India entry strategy" />
        <meta name="author" content="Sars India Liaison" />
        <link rel="canonical" href="https://www.sarsindialiaison.com/" />
      </Helmet>

      <Header4 />
      <HerosectionB />
      <ShortAboutUs />
      <ShortServicesSection />
      <ShortIndustriesServed />
      <ShortOurProcesses />
      {/* <ShortTestimonials/> */}
      {/* <TestimonialSection2/> */}
      <ShortClientCarousel />
      <WhatsappCallBtn />
      <Footer />

    </>
  )
}
